<template>
  <div class="card d-flex justify-content-between shadow-none">
    <div class="card-header ps-10">
      <h3 class="card-title align-items-start flex-column fw-bolder fs-2">
        {{ translate("analysis_page_title") }}
      </h3>
    </div>

    <nav>
      <div
        class="nav nav-tabs mt-10"
        id="nav-tab"
        role="tablist"
      >
        <button
          class="nav-link active min-w-200px fs-5 p-2"
          id="nav-home-tab"
          data-bs-toggle="tab"
          data-bs-target="#nav-home"
          type="button"
          role="tab"
          aria-controls="nav-home"
          aria-selected="true"
        >
          {{ translate("customer_detail_label") }}
        </button>
        <button
          class="nav-link min-w-200px fs-5 p-2"
          id="nav-profile-tab"
          data-bs-toggle="tab"
          data-bs-target="#nav-profile"
          type="button"
          role="tab"
          aria-controls="nav-profile"
          aria-selected="false"
        >
          {{ translate("audit_planning_checklist_name") }}
        </button>
      </div>
    </nav>
    <div
      class="tab-content"
      id="nav-tabContent"
    >
      <!-- ! Customer -->
      <div
        class="tab-pane fade show active"
        id="nav-home"
        role="tabpanel"
        aria-labelledby="nav-home-tab"
      >
        <div class="card-body rounded">
          <!-- Dropdownlar -->
          <div class="row d-flex">
            <div class="row col-lg-8 d-flex">
              <div class="col-lg-4 pe-2 ps-0">
                <Dropdown
                  style="padding: 5px !important"
                  v-model="analysis.customerId"
                  :options="customerList"
                  optionLabel="Value"
                  optionValue="Id"
                  :filter="true"
                  :placeholder="t('analysis_all_customer')"
                  @change="onSelectCustomer(analysis.customerId)"
                  class="mb-1"
                >
                  <template v-slot:indicator>
                    <div
                      class="p-dropdown-trigger"
                      role="button"
                      aria-haspopup="listbox"
                      aria-expanded="false"
                    >
                      <span class="p-dropdown-trigger-icon pi pi-chevron-down"></span>
                    </div>

                    <i
                      v-if="analysis.customerId !== 0"
                      class="p-dropdown-clear-icon pi pi-times"
                      @click="
                        analysis.customerId = 0;
                        onSelectCustomer(analysis.customerId);
                      "
                    ></i>
                  </template>
                </Dropdown>
              </div>
              <div class="col-lg-4 pe-2 ps-0">
                <Dropdown
                  style="padding: 5px !important"
                  v-model.number="analysis.locationId"
                  :options="LocationList"
                  optionLabel="Value"
                  optionValue="Id"
                  :filter="true"
                  :placeholder="t('analysis_all_location')"
                  class="mb-1"
                >
                  <template v-slot:indicator>
                    <div
                      class="p-dropdown-trigger"
                      role="button"
                      aria-haspopup="listbox"
                      aria-expanded="false"
                    >
                      <span class="p-dropdown-trigger-icon pi pi-chevron-down"></span>
                    </div>

                    <i
                      v-if="analysis.locationId !== 0"
                      class="p-dropdown-clear-icon pi pi-times"
                      @click="analysis.locationId = 0"
                    ></i>
                  </template>
                </Dropdown>
              </div>
              <div class="col-lg-4 pe-3 ps-0">
                <Dropdown
                  style="padding: 5px !important"
                  v-model="analysis.projectId"
                  :options="ProjectList"
                  optionLabel="Value"
                  optionValue="Id"
                  :filter="true"
                  :placeholder="t('analysis_all_project')"
                  @change="onSelectProject(analysis.projectId)"
                  class="mb-1"
                >
                  <template v-slot:indicator>
                    <div
                      class="p-dropdown-trigger"
                      role="button"
                      aria-haspopup="listbox"
                      aria-expanded="false"
                    >
                      <span class="p-dropdown-trigger-icon pi pi-chevron-down"></span>
                    </div>

                    <i
                      v-if="analysis.projectId !== 0"
                      class="p-dropdown-clear-icon pi pi-times"
                      @click="
                        analysis.projectId = 0;
                        onSelectProject(analysis.projectId);
                      "
                    ></i>
                  </template>
                </Dropdown>
              </div>
            </div>

            <div class="col-lg-4 d-flex p-0">
              <input
                id="dateBegin"
                :class="`form-control date me-1  ${
                  analysis.beginDate == null || analysis.beginDate == '' ? 'text-gray-400' : 'text-dark'
                }`"
                type="date"
                v-model="analysis.beginDate"
              />
              <input
                id="dateEnd"
                :class="`form-control date me-2  ${
                  analysis.endDate == null || analysis.endDate == '' ? 'text-gray-400' : 'text-dark'
                }`"
                type="date"
                v-model="analysis.endDate"
              />
              <button
                class="btn btn-sm btn-primary"
                @click="onSearch"
              >
                {{ translate("Search") }}
              </button>
            </div>
          </div>

          <!-- Başlık -->
          <div class="row mb-5">
            <h2
              class="mb-1 p-5 text-gray-800"
              v-if="customerId == 0"
            >
              {{ translate("analysis_all_customer") }}
            </h2>
            <h2
              v-else
              class="card-title fw-bolder mb-1 p-5"
            >
              {{ customerName }}
              <span v-if="locationName != ''">/ {{ locationName }}</span>
              <span v-if="projectName != ''"> / {{ projectName }}</span>
            </h2>
          </div>

          <div class="row">
            <!--  Toplam Bilgileri  -->
            <div class="col-lg-6">
              <div class="card h-400px shadow-none p-5 mb-5">
                <h3 class="fw-bolder m-2">{{ translate("analysis_total") }}</h3>

                <BlockUI
                  :loading="totalDatasLoading"
                  class="h-100 position-relative"
                />

                <div
                  v-if="!totalDatasLoading"
                  class="d-flex justify-content-center align-items-center h-100 w-100"
                >
                  <!--  ? Total Datas -->
                  <div
                    class="row"
                    style="text-align: center"
                  >
                    <div class="col-lg-6 d-flex justify-content-center mb-10">
                      <i
                        class="bi bi-geo-alt-fill me-5"
                        style="font-size: x-large"
                      ></i>
                      <div class="d-grid">
                        <span class="fs-4 text-dark fw-bolder lh-1">
                          {{ totalDatas.TotalLocationCount }}
                        </span>
                        <span class="fs-6 text-gray-600 fw-bold">
                          {{ translate("audit_report_summary_location") }}
                        </span>
                      </div>
                    </div>
                    <div class="col-lg-6 d-flex justify-content-center mb-10">
                      <i
                        class="bi bi-diagram-3 me-5"
                        style="font-size: x-large"
                      ></i>
                      <div class="d-grid">
                        <span class="fs-4 text-dark fw-bolder lh-1">
                          {{ totalDatas.TotalProjectCount }}
                        </span>
                        <span class="fs-6 text-gray-600 fw-bold">
                          {{ translate("analysis_project") }}
                        </span>
                      </div>
                    </div>
                    <div class="col-lg-6 d-flex justify-content-center mb-10">
                      <i
                        class="bi bi-journal-check me-5"
                        style="font-size: x-large"
                      ></i>
                      <div class="d-grid">
                        <span class="fs-4 text-dark fw-bolder lh-1">
                          {{ totalDatas.TotalAuditCount }}
                        </span>
                        <span class="fs-6 text-gray-600 fw-bold">
                          {{ translate("Menu_Audit") }}
                        </span>
                      </div>
                    </div>
                    <div class="col-lg-6 d-flex justify-content-center mb-10">
                      <i
                        class="bi bi-person-fill me-5"
                        style="font-size: x-large"
                      ></i>
                      <div class="d-grid">
                        <span class="fs-4 text-dark fw-bolder lh-1">
                          {{ totalDatas.TotalAuditorCount }}
                        </span>
                        <span class="fs-6 text-gray-600 fw-bold">
                          {{ translate("audit_report_summary_auditer") }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!--  Audit Scores -->
            <div class="col-lg-6">
              <div class="card h-400px shadow-none p-5 mb-5 px-10 overflow-auto">
                <h3 class="fw-bolder m-2">
                  {{ translate("analysis_number_of_audits_by_score") }}
                </h3>
                <BlockUI
                  :loading="achievementDataLoading"
                  class="h-100 position-relative"
                />
                <apexchart
                  height="300"
                  v-if="!achievementDataLoading"
                  type="donut"
                  :options="auditAchievementDatas.options"
                  :series="auditAchievementDatas.series"
                >
                </apexchart>
              </div>
            </div>
          </div>

          <div class="row">
            <!--Faaliyet tipi Grafiği-->
            <div
              v-if="!showSelected.location && !showSelected.project"
              class="col-lg-6"
            >
              <div class="card shadow-none h-475px p-5 mb-5">
                <h3 class="card-title fw-bolder m-3 mb-5">{{ translate("analysis_operation_type_title") }}</h3>

                <BlockUI
                  :loading="operationTypeLoading"
                  class="h-100 position-relative"
                />

                <div
                  v-if="customerOperationList.length == 0 && !operationTypeLoading"
                  class="d-flex justify-content-center align-items-center h-100 w-100"
                >
                  <span class="text-gray-600">{{ translate("analysis_no_data_criterie") }}</span>
                </div>
                <div
                  v-if="customerOperationList.length > 0 && !operationTypeLoading"
                  class="table-responsive"
                >
                  <table
                    class="table table-row-dashed table-vertical-center gy-5 table-bordered border fw-bolder"
                    style="border-radius: 5px"
                  >
                    <thead>
                      <tr
                        class="text-muted fw-bolder bg-light rounded fs-6 py-3"
                        style="text-align: center; border-radius: 7px; vertical-align: middle"
                      >
                        <th scope="col-lg-4">{{ translate("analysis_operation_type_name") }}</th>
                        <th scope="col-lg-6">{{ translate("analysis_operation_type_audit_count") }}</th>
                        <th scope="col-lg-2">{{ translate("analysis_operation_type_score") }}</th>
                      </tr>
                    </thead>

                    <tbody style="text-align: center">
                      <tr
                        style="vertical-align: center"
                        class="px-5"
                        v-for="operationItem in customerOperationList"
                        :key="operationItem.Id"
                      >
                        <td class="col-lg-5 ps-5">
                          <span class="fw-bolder">{{ operationItem.OperationName }}</span>
                        </td>
                        <td class="col-lg-3">
                          <span class="fw-bolder text-muted">{{ operationItem.AuditCount }}</span>
                        </td>
                        <td class="col-lg-4 d-flex align-items-center justify-content-center w-100">
                          <div class="d-flex align-items-center justify-content-between mb-2 me-3">
                            <span class="text-muted mr-2 font-size-sm font-weight-bold">{{
                              String(operationItem.AchievementLevel).substring(0, 2)
                            }}</span>
                          </div>
                          <div
                            class="progress progress-xs"
                            style="height: 0.5rem; width: 50%"
                          >
                            <div
                              role="progressbar"
                              aria-valuenow="50"
                              aria-valuemin="0"
                              aria-valuemax="100"
                              class="progress-bar bg-primary"
                              :class="{
                                'progress-bar bg-success': operationItem.AchievementLevel >= 80,
                                'progress-bar bg-primary':
                                  operationItem.AchievementLevel < 60 && operationItem.AchievementLevel > 40,
                                'progress-bar bg-danger': operationItem.AchievementLevel < 40,
                              }"
                              :style="`width: ${String(operationItem.AchievementLevel).substring(0, 2)}%`"
                            ></div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <!-- Son 10 Denetim Listesi -->
            <div
              v-else
              class="col-lg-6"
            >
              <div class="card shadow-none h-475px p-5 mb-5">
                <h3 class="card-title fw-bolder mt-3 mx-3 mb-5">{{ translate("analysis_last_ten_audits") }}</h3>

                <BlockUI
                  :loading="lastAuditsLoading"
                  class="h-100 position-relative"
                />
                <div
                  v-if="lastTenAudit.length > 0"
                  class="accordion overflow-auto h-400px"
                  style="border-width: 1px; border-color: gray"
                  id="accordionExample"
                >
                  <div
                    v-for="audit in lastTenAudit"
                    :key="audit.Id"
                    class="accordion-item"
                  >
                    <h2
                      class="accordion-header"
                      id="headingOne"
                    >
                      <button
                        class="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        :data-bs-target="'#audit' + audit.Id"
                        aria-expanded="true"
                        :aria-controls="'#audit' + audit.Id"
                        @click="auditShow = false"
                      >
                        <div class="w-100 d-flex justify-content-between align-items-center">
                          <div class="d-flex flex-column">
                            <span class="fw-bolder mb-2">
                              {{ audit.BeginDate }}
                            </span>
                            <span class="text-muted">
                              {{ audit.ChecklistName }}
                            </span>
                          </div>
                          <span class="fw-bolder badge badge-light me-5 py-3"
                            >{{ audit.Score }} {{ translate("question_component_input_point") }}
                          </span>
                        </div>
                      </button>
                    </h2>
                    <div
                      :id="'audit' + audit.Id"
                      class="accordion-collapse collapse"
                      aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample"
                    >
                      <div class="accordion-body d-flex justify-content-between align-items-end">
                        <div
                          v-if="!auditShow"
                          class="col-lg-10"
                        >
                          <div
                            v-for="answer in audit.SelectAnswers"
                            :key="answer.Id"
                            class="row mb-2"
                          >
                            <span class="col-lg-6"> {{ answer.AnswerText }} </span>
                            <span class="col-lg-6 fw-bolder">{{ answer.Count }} {{ translate("analysis_count") }}</span>
                          </div>
                        </div>

                        <apexchart
                          v-else
                          height="120"
                          type="pie"
                          :options="auditPieChart.options"
                          :series="auditPieChart.series"
                        >
                        </apexchart>

                        <a
                          v-if="!auditShow"
                          title="Pie Chart"
                          class="btn btn-primary p-2"
                          @click="changeTenAuditGraphic(audit.Id)"
                        >
                          <i class="bi bi-pie-chart fs-3 text-white pe-0"></i>
                        </a>
                        <a
                          v-else
                          title="Table"
                          class="btn btn-primary p-2"
                          @click="changeTenAuditGraphic(audit.Id)"
                        >
                          <i class="bi bi-list-stars fs-3 text-white pe-0"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  v-if="lastTenAudit.length == 0 && !lastAuditsLoading"
                  class="d-flex h-100 align-items-center justify-content-center"
                >
                  <span class="text-gray-600">{{ translate("analysis_no_data_criterie") }}</span>
                </div>
              </div>
            </div>

            <!-- Denetçi grafiği -->
            <div class="col-lg-6">
              <div class="card shadow-none h-475px p-5">
                <h3 class="card-title fw-bolder m-3 mb-5">{{ translate("analysis_auditor_title") }}</h3>

                <BlockUI
                  :loading="auditsLoading"
                  class="h-100 position-relative"
                />
                <div
                  v-if="!auditsLoading"
                  class="min-w-200px mt-20"
                  style="overflow-y: auto"
                >
                  <apexchart
                    height="250"
                    type="bar"
                    :options="auditorDataChart.options"
                    :series="auditorDataChart.series"
                  >
                  </apexchart>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- ! Checklist -->
      <div
        class="tab-pane fade"
        id="nav-profile"
        role="tabpanel"
        aria-labelledby="nav-profile-tab"
      >
        <div class="card-body rounded">
          <!--  Checklist Dropdownlar -->
          <div class="d-flex row mb-10">
            <div class="col-lg-11 row d-flex">
              <div class="col-lg-3 pe-2 ps-0">
                <Dropdown
                  style="padding: 5px !important"
                  class="mb-1"
                  v-model="analysisChecklist.customerId"
                  :options="customerList"
                  optionLabel="Value"
                  optionValue="Id"
                  :filter="true"
                  :placeholder="t('analysis_all_customer')"
                  @change="onSelectCustomer(analysisChecklist.customerId)"
                >
                  <template v-slot:indicator>
                    <div
                      class="p-dropdown-trigger"
                      role="button"
                      aria-haspopup="listbox"
                      aria-expanded="false"
                    >
                      <span class="p-dropdown-trigger-icon pi pi-chevron-down"></span>
                    </div>

                    <i
                      v-if="analysisChecklist.customerId !== 0"
                      class="p-dropdown-clear-icon pi pi-times"
                      @click="
                        analysisChecklist.customerId = 0;
                        onSelectCustomer(analysisChecklist.customerId);
                      "
                    ></i>
                  </template>
                </Dropdown>
              </div>
              <div class="col-lg-3 pe-2 ps-0">
                <Dropdown
                  style="padding: 5px !important"
                  v-model.number="analysisChecklist.locationId"
                  :options="LocationList"
                  optionLabel="Value"
                  optionValue="Id"
                  :filter="true"
                  :placeholder="t('analysis_all_location')"
                  class="mb-1"
                >
                  <template v-slot:indicator>
                    <div
                      class="p-dropdown-trigger"
                      role="button"
                      aria-haspopup="listbox"
                      aria-expanded="false"
                    >
                      <span class="p-dropdown-trigger-icon pi pi-chevron-down"></span>
                    </div>

                    <i
                      v-if="analysisChecklist.locationId !== 0"
                      class="p-dropdown-clear-icon pi pi-times"
                      @click="analysisChecklist.locationId = 0"
                    ></i>
                  </template>
                </Dropdown>
              </div>
              <div class="col-lg-3 pe-3 ps-0">
                <Dropdown
                  style="padding: 5px !important"
                  v-model="analysisChecklist.projectId"
                  :options="ProjectList"
                  optionLabel="Value"
                  optionValue="Id"
                  :filter="true"
                  :placeholder="t('analysis_all_project')"
                  @change="onSelectProject(analysisChecklist.projectId)"
                  class="mb-1"
                >
                  <template v-slot:indicator>
                    <div
                      class="p-dropdown-trigger"
                      role="button"
                      aria-haspopup="listbox"
                      aria-expanded="false"
                    >
                      <span class="p-dropdown-trigger-icon pi pi-chevron-down"></span>
                    </div>

                    <i
                      v-if="analysisChecklist.projectId !== 0"
                      class="p-dropdown-clear-icon pi pi-times"
                      @click="
                        analysisChecklist.projectId = 0;
                        onSelectProject(analysisChecklist.projectId);
                      "
                    ></i>
                  </template>
                </Dropdown>
              </div>
              <div class="col-lg-3 pe-3 ps-0">
                <Dropdown
                  style="padding: 5px !important"
                  v-model="analysisChecklist.checklistId"
                  :options="projectChecklist"
                  optionLabel="Name"
                  optionValue="Id"
                  :filter="true"
                  :placeholder="translate('analysis_checklist_dropdown_all')"
                  class="mb-1"
                >
                  <template v-slot:indicator>
                    <div
                      class="p-dropdown-trigger"
                      role="button"
                      aria-haspopup="listbox"
                      aria-expanded="false"
                    >
                      <span class="p-dropdown-trigger-icon pi pi-chevron-down"></span>
                    </div>

                    <i
                      v-if="analysisChecklist.checklistId !== 0"
                      class="p-dropdown-clear-icon pi pi-times"
                      @click="analysisChecklist.checklistId = 0"
                    ></i>
                  </template>
                </Dropdown>
              </div>
            </div>

            <div class="col-lg-1 d-flex">
              <button
                class="btn btn-sm btn-primary"
                @click="onSearchChecklist()"
              >
                {{ translate("Search") }}
              </button>
            </div>
          </div>

          <span class="mt-10 fs- text-gray-800">{{
            translate("analysis_checklist_tab_info") + auditCount + translate("analysis_checklist_tab_info_after")
          }}</span>
          <div class="row mt-10">
            <!-- Cevap Şıkları Dağılımı -->
            <div class="col-lg-6">
              <div class="card h-450px shadow-none p-5 mb-5">
                <h3 class="card-title fw-bolder mt-3">{{ translate("analysis_checklist_answer_distribution") }}</h3>

                <span
                  v-if="auditCount > 0"
                  class="text-gray-600 mb-5"
                  >{{
                    locale == "en"
                      ? translate("analysis_results") + auditCount + " " + translate("analysis_result_info")
                      : auditCount + " " + translate("analysis_results")
                  }}</span
                >

                <div
                  v-if="!pieLoading"
                  class="mt-10 h-100"
                >
                  <apexchart
                    type="pie"
                    height="250"
                    :options="checklistAnswerPie.options"
                    :series="checklistAnswerPie.series"
                  ></apexchart>
                </div>

                <BlockUI
                  :loading="pieLoading"
                  class="h-100 position-relative"
                />
              </div>
            </div>

            <!-- Aksiyon Listesi -->
            <div class="col-lg-6">
              <div class="card h-450px shadow-none p-5 mb-5">
                <h3 class="fw-bolder mt-3">{{ translate("analysis_requiring_action") }}</h3>
                <span
                  v-if="auditCount > 0"
                  class="text-gray-600 mb-5"
                >
                  <span
                    v-if="auditCount > 0"
                    class="text-gray-600 mb-5"
                    >{{
                      locale == "en"
                        ? translate("analysis_results") + auditCount + " " + translate("analysis_result_info")
                        : auditCount + " " + translate("analysis_results")
                    }}</span
                  >
                </span>
                <BlockUI
                  :loading="actionLoading"
                  class="h-100 position-relative"
                />
                <div class="overflow-auto">
                  <div
                    v-for="(action, index) in actionList"
                    :key="index"
                    class="d-flex border border-gray-300 border-dashed rounded p-5 mb-1"
                  >
                    <div class="flex-grow-1 me-2 me-sm-5">
                      <a class="text-dark fs-6 fw-bold">{{ action.AuditDate }} / {{ action.LocationName }} </a>

                      <span class="text-gray-600 fw-bold d-block fs-7">{{ action.QuestionText }}</span>
                    </div>
                    <span class="badge badge-light-danger align-self-center px-2 fs-6 max-w-150px">{{
                      action.AnswerText
                    }}</span>
                  </div>
                </div>
                <div
                  v-if="!actionLoading && actionList.length == 0"
                  class="d-flex h-100 w-100 align-items-center justify-content-center"
                >
                  <span class="text-gray-600">{{ translate("analysis_no_data_criterie") }}</span>
                </div>
              </div>
            </div>
          </div>

          <!--  Bölüm Bazlı Dağılım -->
          <div class="row p-5">
            <div class="card d-flex flex-column justify-content-between p-5 shadow-none">
              <h3 class="fw-bolder">{{ translate("analysis_department_based_distribution") }}</h3>

              <span
                v-if="!changeDepTab && auditCount > 0"
                class="mb-10 text-gray-600"
              >
                <span
                  v-if="auditCount > 0"
                  class="text-gray-600 mb-5"
                  >{{
                    locale == "en"
                      ? translate("analysis_results") + auditCount + " " + translate("analysis_result_info")
                      : auditCount + " " + translate("analysis_results")
                  }}</span
                ></span
              >
              <span
                v-else-if="changeDepTab && auditCount > 0"
                class="mb-10 text-gray-600"
              >
                {{ translate("analysis_department_comparison_subtitle") }}</span
              >
              <BlockUI
                :loading="departmentLoading"
                class="h-300px position-relative"
              />

              <div
                v-if="departmentScoreList.length == 0 && !departmentLoading"
                class="d-flex h-300px align-items-center justify-content-center"
              >
                <span class="text-gray-600">{{ translate("analysis_no_data_criterie") }}</span>
              </div>

              <div v-if="departmentScoreList.length > 0">
                <ul
                  class="nav nav-tabs"
                  id="myTab"
                  role="tablist"
                >
                  <li
                    class="nav-item"
                    role="presentation"
                  >
                    <button
                      style="min-width: 150px"
                      class="nav-link active p-2"
                      id="departmentResult-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#departmentResult"
                      type="button"
                      role="tab"
                      aria-controls="departmentResult"
                      aria-selected="true"
                      @click="changeDepTab = false"
                    >
                      <span class="fs-5">{{ translate("analysis_department_score") }}</span>
                    </button>
                  </li>
                  <li
                    class="nav-item"
                    role="presentation"
                  >
                    <button
                      style="min-width: 150px"
                      class="nav-link p-2"
                      id="department-answer-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#department-answer"
                      type="button"
                      role="tab"
                      aria-controls="department-answer"
                      aria-selected="false"
                      @click="changeDepTab = false"
                    >
                      <span class="fs-5">{{ translate("analysis_department_answer") }}</span>
                    </button>
                  </li>
                  <li
                    v-if="analysisChecklist.locationId != 0"
                    class="nav-item"
                    role="presentation"
                  >
                    <button
                      style="min-width: 150px"
                      class="nav-link p-2"
                      id="department-last-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#department-last"
                      type="button"
                      role="tab"
                      aria-controls="department-last"
                      aria-selected="false"
                      @click="changeDepTab = true"
                    >
                      <span class="fs-5">{{ translate("analysis_department_comparison") }}</span>
                    </button>
                  </li>
                </ul>
                <div
                  class="tab-content"
                  id="myTabContent"
                >
                  <div
                    class="tab-pane fade show active"
                    id="departmentResult"
                    role="tabpanel"
                    aria-labelledby="departmentResult-tab"
                  >
                    <div class="mt-10">
                      <div class="fs-5 fw-bold border-0 text-dark row ms-2">
                        <span class="min-w-300px col-lg-7">{{ translate("analysis_department_tab_title") }}</span>
                        <span class="min-w-100px col-lg-5">{{ translate("analysis_average_score") }}</span>
                      </div>
                      <div
                        v-for="department in departmentScoreList"
                        :key="department.DepartmentId"
                        class="p-5 d-flex row"
                      >
                        <span class="text-gray-800 fw-bold mb-1 fs-6 col-lg-7"> {{ department.DepartmentName }}</span>
                        <div class="d-flex align-items-center border-0 col-lg-4">
                          <span class="fw-bold text-gray-800 fs-6 me-3 col-lg-2">{{
                            String(department.EarnedScore / department.DepartmentCount).substring(0, 4)
                          }}</span>

                          <div class="progress rounded-start-0 border-0">
                            <div
                              class="progress-bar bg-primary m-0"
                              role="progressbar"
                              :style="`height: 12px; width:${
                                (department.EarnedScore * 3) / department.DepartmentCount
                              }px`"
                              aria-valuenow="166"
                              aria-valuemin="0"
                              aria-valuemax="166px"
                            ></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="tab-pane fade mb-10 overflow-auto"
                    id="department-answer"
                    role="tabpanel"
                    aria-labelledby="department-answer-tab"
                  >
                    <apexchart
                      class="mt-15"
                      height="400"
                      :options="departmentAnswerChart.options"
                      :series="departmentAnswerChart.series"
                    ></apexchart>
                  </div>
                  <div
                    v-if="analysisChecklist.locationId != 0"
                    class="tab-pane fade mb-10 overflow-auto"
                    id="department-last"
                    role="tabpanel"
                    aria-labelledby="department-last-tab"
                  >
                    <apexchart
                      class="mt-10"
                      type="radar"
                      width="800"
                      height="300"
                      :options="twoAuditDepartmentChart.options"
                      :series="twoAuditDepartmentChart.series"
                    ></apexchart>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!--  Kategori Bazlı Dağılım -->
          <div class="row p-5">
            <div class="card d-flex flex-column justify-content-between p-5 shadow-none">
              <h3 class="fw-bolder">{{ translate("analysis_category_based_distribution") }}</h3>
              <span
                v-if="!changeCatTab && auditCount > 0"
                class="mb-10 text-gray-600"
              >
                <span
                  v-if="auditCount > 0"
                  class="text-gray-600 mb-5"
                  >{{
                    locale == "en"
                      ? translate("analysis_results") + auditCount + " " + translate("analysis_result_info")
                      : auditCount + " " + translate("analysis_results")
                  }}</span
                ></span
              >
              <span
                class="mb-10 text-gray-600"
                v-else-if="changeCatTab && auditCount > 0"
                >{{ translate("analysis_department_comparison_subtitle") }}</span
              >
              <BlockUI
                :loading="categoryLoading"
                class="h-300px position-relative"
              />

              <div
                v-if="categoryScoreList.length == 0 && !categoryLoading"
                class="d-flex h-300px align-items-center justify-content-center"
              >
                <span class="text-gray-600">{{ translate("analysis_no_data_criterie") }}</span>
              </div>
              <div v-if="categoryScoreList.length > 0">
                <ul
                  class="nav nav-tabs"
                  id="myTab"
                  role="tablist"
                >
                  <li
                    class="nav-item"
                    role="presentation"
                  >
                    <button
                      style="min-width: 150px"
                      class="nav-link active p-2"
                      id="category-result-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#category-result"
                      type="button"
                      role="tab"
                      aria-controls="category-result"
                      aria-selected="true"
                      @click="changeCatTab = false"
                    >
                      <span class="fs-5">{{ translate("analysis_department_score") }}</span>
                    </button>
                  </li>
                  <li
                    class="nav-item"
                    role="presentation"
                  >
                    <button
                      style="min-width: 150px"
                      class="nav-link p-2"
                      id="category-answer-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#category-answer"
                      type="button"
                      role="tab"
                      aria-controls="category-answer"
                      aria-selected="false"
                      @click="changeCatTab = false"
                    >
                      <span class="fs-5">{{ translate("analysis_department_answer") }}</span>
                    </button>
                  </li>
                  <li
                    v-if="analysisChecklist.locationId != 0"
                    class="nav-item"
                    role="presentation"
                  >
                    <button
                      style="min-width: 150px"
                      class="nav-link p-2"
                      id="category-last-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#category-last"
                      type="button"
                      role="tab"
                      aria-controls="category-last"
                      aria-selected="false"
                      @click="changeCatTab = true"
                    >
                      <span class="fs-5">{{ translate("analysis_department_comparison") }}</span>
                    </button>
                  </li>
                </ul>
                <div
                  class="tab-content"
                  id="myTabContent"
                >
                  <div
                    class="tab-pane fade show active max-h-500px"
                    id="category-result"
                    role="tabpanel"
                    aria-labelledby="category-result-tab"
                  >
                    <div class="mt-10">
                      <div class="fs-5 fw-bold border-0 text-dark row ms-2">
                        <span class="min-w-300px col-lg-7">{{ translate("analysis_category_tab_title") }}</span>
                        <span class="min-w-100px col-lg-5">{{ translate("analysis_average_score") }}</span>
                      </div>
                      <div
                        v-for="category in categoryScoreList"
                        :key="category.CategoryId"
                        class="p-5 d-flex row"
                      >
                        <span class="text-gray-800 fw-bold mb-1 fs-6 col-lg-7"> {{ category.CategoryName }}</span>
                        <div class="d-flex align-items-center border-0 col-lg-4">
                          <span class="fw-bold text-gray-800 fs-6 me-3 col-lg-2">{{
                            String(category.EarnedScore / category.CategoryCount).substring(0, 4)
                          }}</span>

                          <div class="progress rounded-start-0 border-0">
                            <div
                              class="progress-bar bg-primary m-0"
                              role="progressbar"
                              :style="`height: 12px; width:${(category.EarnedScore * 3) / category.CategoryCount}px`"
                              aria-valuenow="166"
                              aria-valuemin="0"
                              aria-valuemax="166px"
                            ></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="tab-pane fade mb-10 overflow-auto"
                    id="category-answer"
                    role="tabpanel"
                    aria-labelledby="category-answer-tab"
                  >
                    <apexchart
                      class="mt-15"
                      height="400"
                      :options="categoryAnswerChart.options"
                      :series="categoryAnswerChart.series"
                    ></apexchart>
                  </div>
                  <div
                    v-if="analysisChecklist.locationId != 0"
                    class="tab-pane fade mb-10 overflow-auto"
                    id="category-last"
                    role="tabpanel"
                    aria-labelledby="category-last-tab"
                  >
                    <apexchart
                      class="mt-15"
                      type="radar"
                      width="700"
                      height="300"
                      :options="twoAuditCategoryChart.options"
                      :series="twoAuditCategoryChart.series"
                    ></apexchart>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { reactive, ref, computed, onMounted, watch } from "vue";
import { useStore } from "vuex";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";

import { useI18n } from "vue-i18n";
const { t, te, locale } = useI18n();
const translate = (text) => {
  if (te(text)) {
    return t(text);
  } else {
    return text;
  }
};

const store = useStore();

//değişkenler
const customerId = ref(0);
const auditCount = ref(0);
const totalAuditPlan = ref(0);

//Başlıklar
const customerName = ref("");
const locationName = ref("");
const projectName = ref("");

//Loadingler
const actionLoading = ref(false);
const departmentLoading = ref(false);
const categoryLoading = ref(false);
const pieLoading = ref(false);
const operationTypeLoading = ref(false);
const lastAuditsLoading = ref(false);
const achievementDataLoading = ref(false);
const totalDatasLoading = ref(false);
const auditsLoading = ref(false);

//Listeler
const departmentScoreList = ref([]);
const categoryScoreList = ref([]);
const customerList = ref([]);
const actionList = ref([]);
const lastTenAudit = ref([]);
const customerOperationList = ref([]);
const auditList = ref([]);

//Tab değiştirme checklist dep-cat
const changeCatTab = ref(false);
const changeDepTab = ref(false);
const auditShow = ref(false);

let categoryJoinList = [];
let joinList = [];

const lazyParams = ref([]);

lazyParams.value = {
  page: 1,
  pageSize: 10,
  sortColumn: null,
  sortDirection: null,
  customerId: 0,
  locationId: 0,
  projectId: 0,
  beginDate: null,
  endDate: null,
};

//Reaktif obje tanımlamaları

const analysis = reactive({
  customerId: 0,
  locationId: 0,
  projectId: 0,
  beginDate: null,
  endDate: null,
  checklistId: 0,
});

const analysisChecklist = reactive({
  customerId: 0,
  locationId: 0,
  projectId: 0,
  checklistId: 0,
});

const totalDatas = ref({
  TotalAuditorCount: 0,
  TotalLocationCount: 0,
  TotalProjectCount: 0,
  TotalAuditCount: 0,
});

//Müşteri,location,proje seçilme durumu (grafik değişikleri için)
const showSelected = ref({
  customer: false,
  location: false,
  project: false,
  checklist: false,
});

// Seçimleri temizleme
const clearSelect = () => {
  showSelected.value.customer = false;
  showSelected.value.location = false;
  showSelected.value.project = false;
};

// Puan aralığına göre denetim sayısı grafik
const auditAchievementDatas = ref({
  options: {
    chart: {
      type: "donut",
      height: "400px",
      width: "40%",
    },
    dataLabels: {
      enabled: false,
    },
    noData: {
      text: translate("analysis_no_data_criterie"),
      align: "center",
      verticalAlign: "middle",
      offsetX: 0,
      offsetY: 0,
      style: {
        color: "#718096",
        fontSize: "13px",
        fontFamily: undefined,
        height: "400px",
      },
    },
    plotOptions: {
      pie: {
        customScale: 0.8,
        offsetY: 20,
      },
      stroke: {
        colors: undefined,
      },
    },

    yaxis: {
      labels: {
        formatter: function (value) {
          return value + " " + translate("dashboard_audit");
        },
      },
    },

    labels: [
      "0-40 " + translate("analysis_score"),
      "40-60 " + translate("analysis_score"),
      "60-80 " + translate("analysis_score"),
      "80-100 " + translate("analysis_score"),
    ],
    legend: {
      position: "left",
      offsetY: 40,
      fontSize: 14,
      itemMargin: {
        horizontal: 0,
        vertical: 5,
      },
    },
  },
  series: [{ data: [] }],
});

//Müşteri getirme
const getCustomers = () => {
  store.dispatch("CustomerModule/GET_COMMONN_CUSTOMERS").then((response) => {
    customerList.value = response;
    response.forEach((element) => {
      if (analysis.customerId > 0) {
        if (analysis.customerId == element.Id) {
          customerName.value = element.Value;
          customerId.value = element.Id;
        }
      } else customerId.value = 0;
    });
  });
};

// Dropdown seçme
const onSelectCustomer = (customerId) => {
  analysis.projectId = 0;
  analysis.locationId = 0;
  analysisChecklist.projectId = 0;
  analysisChecklist.checklistId = 0;
  analysisChecklist.locationId = 0;

  store.dispatch("AuditPlanningModule/GET_COMMON_LOCATION", customerId ? customerId : 0);
  store.dispatch("AuditPlanningModule/GET_COMMON_CPROJECT", customerId ? customerId : 0);
};
const onSelectProject = (projectId) => {
  analysisChecklist.checklistId = 0;
  store.dispatch("ProjectModule/GET_PROJECT_CHECKLIST", {
    projectId: projectId ? projectId : 0,
    page: 1,
    pageSize: 100000,
  });
};

//Listeler
const ProjectList = computed(() => store.getters["AuditPlanningModule/_getCProjectList"]);
const LocationList = computed(() => store.getters["AuditPlanningModule/_getLocationList"]);
const projectChecklist = computed(() => store.getters["ProjectModule/_getChecklist"]);

//Son 10 Denetim pie Chart
const auditPieChart = ref({
  options: {
    chart: {
      width: 100,
      type: "donut",
    },
    sparkline: {
      enabled: true,
    },
    dataLabels: {
      enabled: false,
    },
    labels: [],
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 200,
          },
          legend: {
            show: false,
          },
        },
      },
    ],
    legend: {
      position: "right",
      offsetY: 0,
      height: 350,
    },
  },
  series: [],
});

// Son 10 denetim channge button
const changeTenAuditGraphic = (id) => {
  let audit = lastTenAudit.value.find((item) => item.Id === id);
  auditPieChart.value.options.labels = audit.SelectAnswers.map((item) => item.AnswerText);
  auditPieChart.value.series = audit.SelectAnswers.map((item) => item.Count);
  auditShow.value = !auditShow.value;
};

//Denetçi grafik (bar chart)
const auditorDataChart = ref({
  options: {
    chart: {
      height: 300,
      type: "bar",
      zoom: {
        enabled: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "straight",
    },
    title: {
      align: "left",
    },
    plotOptions: {
      bar: {
        borderRadius: 10,
        columnWidth: "40%",
      },
    },
    legend: {
      show: false,
    },
    colors: ["#214cc5"],

    fill: {
      type: "gradient",
      gradient: {
        gradientToColors: ["#3464C3"],
        shade: "dark",
        type: "vertical",
        shadeIntensity: 0.5,
        inverseColors: false,
        opacityFrom: 1,
        opacityTo: 0.8,
        stops: [0, 100],
      },
    },
    xaxis: {
      categories: [],
    },
    noData: {
      text: translate("analysis_no_data_criterie"),
      align: "center",
      verticalAlign: "middle",
      offsetX: 0,
      offsetY: 0,
      style: {
        color: "#718096",
        fontSize: "13px",
        fontFamily: undefined,
        height: "400px",
      },
    },
  },
  series: [
    {
      name: translate("Menu_Audit"),
      data: [],
    },
  ],
});

//Customer Tab - arama
const onSearch = () => {
  clearSelect();

  operationTypeLoading.value = true;
  lastAuditsLoading.value = true;
  auditsLoading.value = true;
  achievementDataLoading.value = true;
  totalDatasLoading.value = true;

  lazyParams.value.customerId = analysis.customerId;
  lazyParams.value.locationId = analysis.locationId;
  lazyParams.value.projectId = analysis.projectId;

  store.dispatch("DashboardModule/GET_ANALYSIS_CUSTOMERS", analysis).then((response) => {
    store.dispatch("DashboardModule/GET_CUSTOMER_AUDITPLANS", lazyParams.value).then((response) => {
      auditList.value = response.ListItems;

      totalAuditPlan.value = response.TotalItemsCount;
    });

    if (response) {
      // Puan aralığına denetim sayısı grafiği pie chart
      let countList = response.AuditAchievementDatas.map((item) => item.count);
      auditAchievementDatas.value.series = countList;

      if (countList.every((item) => item === 0)) {
        auditAchievementDatas.value.series = [];
        auditAchievementDatas.value.options.labels = [];
      } else {
        auditAchievementDatas.value.options.labels = [
          "0-40 " + translate("analysis_score"),
          "40-60 " + translate("analysis_score"),
          "60-80 " + translate("analysis_score"),
          "80-100 " + translate("analysis_score"),
        ];
      }

      // Auditor puan aralığı
      auditorDataChart.value.options.xaxis.categories = response.AuditorInfoAuditPlanModels.map(
        (item) => item.AuditorName
      );
      auditorDataChart.value.series[0].data = response.AuditorInfoAuditPlanModels.map((item) => item.AuditCount);

      // Proje Seçili İse
      if (analysis.projectId != 0) {
        Object.keys(totalDatas.value).forEach((key) => (totalDatas.value[key] = response.ProjectAudits[key]));

        showSelected.value.project = true;
        lastTenAudit.value = response.ProjectAudits.LastTenAudits;
      }

      //Lokasyon Seçili İse
      else if (analysis.locationId != 0) {
        showSelected.value.location = true;
        lastTenAudit.value = response.LocationAudits.LastTenAudits;
      }

      //Customer Seçili ise
      else {
        Object.keys(totalDatas.value).forEach((key) => (totalDatas.value[key] = response.CustomerAudits[key]));

        showSelected.value.customer = true;
        //Operation Type Datas
        customerOperationList.value = response.CustomerAudits.Operations;
      }
    }

    operationTypeLoading.value = false;
    lastAuditsLoading.value = false;
    auditsLoading.value = false;
    achievementDataLoading.value = false;
    totalDatasLoading.value = false;
  });
};

//checklistteki cevapların dağılımı pieChart
const checklistAnswerPie = ref({
  options: {
    chart: {
      type: "pie",
    },
    noData: {
      text: translate("analysis_no_data_criterie"),
      align: "center",
      verticalAlign: "middle",
      offsetX: 0,
      offsetY: 0,
      style: {
        color: "#718096",
        fontSize: "13px",
        fontFamily: undefined,
        height: "400px",
      },
    },
    xaxis: {
      labels: {
        formatter: function (value) {
          return value + " seçim";
        },
      },
    },
    yaxis: {
      labels: {
        formatter: function (value) {
          return value + " seçim";
        },
      },
    },
    labels: [],
  },
  series: [],
});

//departmandaki cevapların dağılımı barChart
const departmentAnswerChart = ref({
  options: {
    chart: {
      type: "bar",
      height: 350,
    },
    plotOptions: {
      bar: {
        horizontal: false,
        endingShape: "rounded",
      },
    },

    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: true,
      width: 2,
      colors: ["transparent"],
    },
    xaxis: {
      categories: [],
      labels: {
        trim: true,
        rotate: -45,
        formatter: (value) => {
          var len = value.length;
          return len > 15 ? value.substring(0, 10) + "..." : value;
        },
      },
    },
    yaxis: {
      title: {
        text: translate("analysis_answer_count"),
      },
    },
    fill: {
      opacity: 1,
    },
    noData: {
      text: translate("analysis_no_data_criterie"),
      align: "center",
      verticalAlign: "middle",
      offsetX: 0,
      offsetY: 0,
      style: {
        color: "#718096",
        fontSize: "13px",
        fontFamily: undefined,
      },
    },
  },
  series: [],
});

//kategorideki cevapların dağılımı barChart
const categoryAnswerChart = ref({
  options: {
    chart: {
      type: "bar",
      height: 350,
    },
    plotOptions: {
      bar: {
        horizontal: false,
        endingShape: "rounded",
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: true,
      width: 2,
      colors: ["transparent"],
    },
    xaxis: {
      categories: [],
      labels: {
        trim: true,
        rotate: -45,
        formatter: (value) => {
          var len = value.length;
          return len > 15 ? value.substring(0, 10) + "..." : value;
        },
      },
    },
    yaxis: {
      title: {
        text: translate("analysis_answer_count"),
      },
    },
    fill: {
      opacity: 1,
    },
    noData: {
      text: translate("analysis_no_data_criterie"),
      align: "center",
      verticalAlign: "middle",
      offsetX: 0,
      offsetY: 0,
      style: {
        color: "#718096",
        fontSize: "13px",
        fontFamily: undefined,
      },
    },
  },
  series: [],
});

//Departmandaki son iki denetim karşılaştırması radarChart
const twoAuditDepartmentChart = ref({
  options: {
    chart: {
      height: 150,
      width: 500,
      type: "radar",
    },
    dataLabels: {
      enabled: false,
    },
    plotOptions: {
      radar: {
        size: 120,
      },
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return val;
        },
      },
    },
    xaxis: {
      categories: [],
      labels: {
        show: true,
      },
    },
    yaxis: {
      labels: {
        formatter: function (val, i) {
          if (i % 2 === 0) {
            return val;
          } else {
            return "";
          }
        },
      },
    },
    markers: {
      size: 3,
    },
    stroke: {
      width: 1,
    },
    colors: ["red", "blue"],
    legend: {
      position: "right",
    },
    noData: {
      text: translate("analysis_no_data_criterie"),
      align: "center",
      verticalAlign: "middle",
      offsetX: 0,
      offsetY: 0,
      style: {
        color: "#718096",
        fontSize: "13px",
        fontFamily: undefined,
        height: "400px",
      },
    },
  },
  series: [],
});

//Kategorideki son iki denetim karşılaştırması radarChart
const twoAuditCategoryChart = ref({
  options: {
    chart: {
      height: 150,
      width: 500,
      type: "radar",
    },
    dataLabels: {
      enabled: false,
    },
    plotOptions: {
      radar: {
        size: 120,
      },
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return val;
        },
      },
    },
    xaxis: {
      categories: [],
      labels: {
        show: true,
      },
    },
    yaxis: {
      labels: {
        formatter: function (val, i) {
          if (i % 2 === 0) {
            return val;
          } else {
            return "";
          }
        },
      },
    },
    markers: {
      size: 3,
    },
    stroke: {
      width: 1,
    },
    colors: ["red", "blue"],
    legend: {
      position: "right",
    },
    noData: {
      text: translate("analysis_no_data_criterie"),
      align: "center",
      verticalAlign: "middle",
      offsetX: 0,
      offsetY: 0,
      style: {
        color: "#718096",
        fontSize: "13px",
        fontFamily: undefined,
        height: "400px",
      },
    },
  },
  series: [],
});

// son 2 denetim radarChart verileri
let twoAuditDepartment = [
  {
    name: "1.Denetim",
    data: [],
  },
  {
    name: "2. Denetim",
    data: [],
  },
];
let twoAuditCategory = [
  {
    name: "1.Denetim",
    data: [],
  },
  {
    name: "2. Denetim",
    data: [],
  },
];

// checklist tab- arama
const onSearchChecklist = () => {
  actionLoading.value = true;
  pieLoading.value = true;
  departmentLoading.value = true;
  categoryLoading.value = true;

  departmentScoreList.value = [];
  categoryScoreList.value = [];
  actionList.value = [];
  checklistAnswerPie.value.options.labels = [];
  checklistAnswerPie.value.series = [];

  changeCatTab.value = false;
  changeDepTab.value = false;

  departmentAnswerChart.value.options.xaxis.categories = [];
  departmentAnswerChart.value.series = [];
  categoryJoinList = [];
  joinList = [];

  store
    .dispatch("AuditReportModule/CHECKLIST_ANALYSİS", {
      projectId: analysisChecklist.projectId,
      locationId: analysisChecklist.locationId,
      checklistId: analysisChecklist.checklistId,
    })
    .then((response) => {
      let groupAnswers = [];

      let departmentAnswers = [];
      departmentScoreList;
      let categoryAnswers = [];

      auditCount.value = response.length;
      response.forEach((audit, auditIndex) => {
        //Cevaplar
        audit.Answers.forEach((answer) => {
          let answerTemplate = groupAnswers.find((group) => group.Id === answer.Id);
          if (answerTemplate) {
            answerTemplate.Count += answer.Count;
          } else {
            groupAnswers.push(answer);
          }
        });

        //Aksiyonlar
        audit.ActionRequiredQuestions.forEach((question) => {
          const modelActionQ = {
            AuditDate: audit.AuditDate,
            LocationName: audit.LocationName,
            AuditPlanId: question.AuditPlanId,
            QuestionId: question.QuestionId,
            QuestionText: question.QuestionText,
            AnswerText: question.AnswerText,
            Count: question.Count,
          };
          let actionQuestion = actionList.value.find(
            (actionQ) =>
              actionQ.AuditPlanId === modelActionQ.AuditPlanId && actionQ.QuestionId === modelActionQ.QuestionId
          );
          if (actionQuestion) {
            actionQuestion.Count += modelActionQ.Count;
          } else {
            actionList.value.push(modelActionQ);
          }
        });

        // Denetim skorlarını departmana göre gruplama
        departmentScoreList.value = groupDepartmentScores(audit.DepartmentScores);

        // Denetim skorlarını kategoriye göre gruplama
        categoryScoreList.value = groupCategoryScores(audit.CategoryScores);
        //Denetim Cevaplarını Departmana Göre Ayırma

        audit.DepartmentAnswers.forEach((department) => {
          let answerControl = departmentAnswers.find(
            (item) => item.Id === department.Id && item.DepartmentId === department.DepartmentId
          );

          //Departman isimleri gelmediği için score listesinden idsi eşleşen departman ismi alınacak

          if (departmentScoreList.value.length > 0) {
            let currentDepartment = departmentScoreList.value.find(
              (item) => item.DepartmentId === department.DepartmentId
            );
            if (answerControl) {
              answerControl.Count += department.Count;
            } else {
              const modelDepAnswers = {
                AnswerText: department.AnswerText,
                DepartmentId: department.DepartmentId,
                Id: department.Id,
                DepartmentName: currentDepartment ? currentDepartment.DepartmentName : translate("Other"),
                Count: department.Count,
              };
              departmentAnswers.push(modelDepAnswers);
            }
          }
        });

        //Denetim Cevaplarını Kategoriye Göre Ayırma
        audit.CategoryAnswers.forEach((category) => {
          let answerControl = categoryAnswers.find(
            (item) => item.Id === category.Id && item.CategoryId === category.CategoryId
          );

          if (audit.CategoryScores.length > 0) {
            let currentCategory = audit.CategoryScores.find((item) => item.CategoryId === category.CategoryId);
            let modelCatAnswers = {
              AnswerText: category.AnswerText,
              CategoryId: category.CategoryId,
              Id: category.Id,
              CategoryName: currentCategory
                ? currentCategory.CategoryId != 0
                  ? currentCategory.CategoryName
                  : translate("Other")
                : translate("Other"),
              Count: category.Count,
            };

            if (answerControl) {
              answerControl.Count += modelCatAnswers.Count;
            } else {
              categoryAnswers.push(modelCatAnswers);
            }
          }
        });

        //Son iki denetimin skorlarını departmana göre gruplama
        if (auditIndex == 0) {
          let oneAuditDepartment = groupDepartmentScores(audit.DepartmentScores);
          twoAuditDepartmentChart.value.options.xaxis.categories = oneAuditDepartment.map(
            (department) => department.DepartmentName
          );
          twoAuditDepartment[0].data = oneAuditDepartment.map(
            (department) => department.EarnedScore / department.DepartmentCount
          );

          let oneAuditCategory = groupCategoryScores(audit.CategoryScores);
          twoAuditCategoryChart.value.options.xaxis.categories = oneAuditCategory.map(
            (category) => category.CategoryName
          );
          twoAuditCategory[0].data = oneAuditCategory.map((category) => category.EarnedScore / category.CategoryCount);
        } else if (auditIndex == 1) {
          let twoAuditDep = groupDepartmentScores(audit.DepartmentScores);
          twoAuditDepartment[1].data = twoAuditDep.map(
            (department) => department.EarnedScore / department.DepartmentCount
          );

          let twoAuditCat = groupCategoryScores(audit.CategoryScores);
          twoAuditCategory[1].data = twoAuditCat.map((category) => category.EarnedScore / category.CategoryCount);
        }
      });

      // Departman gruplaması
      let groupDepartmentAnswer = groupBy(departmentAnswers, "DepartmentName");
      // Departman Cevap grafiğinde cevap listesini alındı
      let seriesAnswers = [];
      groupAnswers.forEach((item) => {
        seriesAnswers.push({ name: item.AnswerText, data: [] });
      });

      // Departman Cevap Grafiği için gruplanmış departmanlar istenilen şekle dönüştürüldü
      Object.keys(groupDepartmentAnswer).forEach((item) => {
        departmentAnswerChart.value.options.xaxis.categories.push(item);
        groupDepartmentAnswer[item].forEach((element) => {
          const currentItem = seriesAnswers.find((item) => item.name === element.AnswerText);
          currentItem.data.push(element.Count);
        });
      });
      departmentAnswerChart.value.series = seriesAnswers;

      //Kategori Gruplaması
      let groupCategoryAnswer = groupBy(categoryAnswers, "CategoryName");

      // Kategori Cevap grafiğinde cevap listesini alındı
      let seriesCategoryAnswers = [];
      groupAnswers.forEach((item) => {
        seriesCategoryAnswers.push({ name: item.AnswerText, data: [] });
      });

      // Kategori Cevap Grafiği için gruplanmış kategoriler istenilen şekle dönüştürüldü
      Object.keys(groupCategoryAnswer).forEach((item) => {
        categoryAnswerChart.value.options.xaxis.categories.push(item);
        groupCategoryAnswer[item].forEach((element) => {
          const currentItem = seriesCategoryAnswers.find((item) => item.name === element.AnswerText);
          currentItem.data.push(element.Count);
        });
      });

      categoryAnswerChart.value.series = seriesCategoryAnswers;

      checklistAnswerPie.value.options.labels = groupAnswers.map((answer) => answer.AnswerText);
      checklistAnswerPie.value.series = groupAnswers.map((answer) => answer.Count);
      pieLoading.value = false;
      actionLoading.value = false;
      departmentLoading.value = false;
      categoryLoading.value = false;
    });

  twoAuditDepartmentChart.value.series = twoAuditDepartment;
  twoAuditCategoryChart.value.series = twoAuditCategory;
};

//Kategori Ve departmanları gruplama
const groupBy = (list, key) => {
  return list.reduce((rv, x) => {
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});
};

//Denetim listesindeki departmanlar ve skorları gruplandı
const groupDepartmentScores = (departmentList) => {
  departmentList.forEach((department) => {
    let departmentModel = {
      DepartmentId: department.DepartmentId,
      DepartmentName: department.DepartmentName ? department.DepartmentName : translate("Other"),
      EarnedScore: parseInt(department.EarnedScore),
      DepartmentCount: 1,
    };
    const departmentControl = joinList.find((element) => element.DepartmentId === department.DepartmentId);
    if (departmentControl) {
      departmentControl.EarnedScore += departmentModel.EarnedScore;
      departmentControl.DepartmentCount = departmentControl.DepartmentCount + 1;
    } else {
      joinList.push(departmentModel);
    }
  });
  return joinList;
};

//Denetim listesindeki kategoriler ve skorları gruplandı
const groupCategoryScores = (categoryList) => {
  categoryList.forEach((category) => {
    let categoryModel = {
      CategoryId: category.CategoryId,
      CategoryName: category.CategoryName ? category.CategoryName : translate("Other"),
      EarnedScore: parseInt(category.EarnedScore),
      CategoryCount: 1,
    };
    const categoryControl = categoryJoinList.find((element) => element.CategoryId === category.CategoryId);
    if (categoryControl) {
      categoryControl.EarnedScore += categoryModel.EarnedScore;
      categoryControl.CategoryCount = categoryControl.CategoryCount + 1;
    } else {
      categoryJoinList.push(categoryModel);
    }
  });

  return categoryJoinList;
};

getCustomers();
onSearch();
onSearchChecklist();

watch(locale, () => {
  setCurrentPageBreadcrumbs(translate("analysis_page_title"), []);
});

onMounted(() => {
  setCurrentPageBreadcrumbs(translate("analysis_page_title"), []);
});
</script>
<style scoped>
.card {
  border: 1px solid #eff2f5;
}

/* .nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  background-color: #ececec;
}
.nav-link {
  color: #3f4254 !important;
} */
</style>
